export default __webpack_public_path__ + "static/media/notifications_7.ce723496.png";